const $inject = ['$q', 'moment', 'itinerariesService', '$filter'];

const searchFormService = function ($q, moment, itinerariesService, $filter) {
  let service = {
    activeSearchTypes: {
      Flights: {active: true, showForm: true},
      Rail: {active: false, showForm: false},
      Hotels: {active: false, showForm: false},
      Cars: {active: false, showForm: false}
    },
    railOptions: {
      return: true,
      openReturn: false
    },
    flightLegs: 2,
    updateSearchChoices,
    updateFlightLegs,
    updateRailReturn,
    updateRailOpenReturn,
    validateThenPostForm,
    prepRailFormData,
    prepCarFormData,
    prepHotelFormData
  };

  const DATE_FORMAT_UPPER = $filter('translate')('dates.DateFormat');
  const TIME_FORMAT = $filter('translate')('dates.TimeFormatLong');

  function prepCarFormData(searchForm) {
    let DATE_FORMAT_MEDIUM = $filter('translate')('dates.DateFormatMedium').replace(',', '[,]');
    let pickUpDateTime = `${searchForm.pickUpDate.$modelValue} ${searchForm.pickUpTime.$modelValue}`;
    let pickUpDateTimeParsed = moment(pickUpDateTime, `${DATE_FORMAT_MEDIUM} ${TIME_FORMAT}`).format('YYYY-MM-DD[T]HH:mm:ss');

    let dropOffDateTime = `${searchForm.dropOffDate.$modelValue} ${searchForm.dropOffTime.$modelValue}`;
    let dropOffDateTimeParsed = moment(dropOffDateTime, `${DATE_FORMAT_MEDIUM} ${TIME_FORMAT}`).format('YYYY-MM-DD[T]HH:mm:ss');
    let pickupLocation = searchForm.pickUpDepot.$modelValue.Name;
    let pickupCode = searchForm.pickUpDepot.$modelValue.Value;
    let pickupCity = searchForm.pickUpCity.$modelValue.City;
    let pickupCityCode = searchForm.pickUpCity.$modelValue.CityCode;
    let pickupCountry = searchForm.pickUpCity.$modelValue.Country;
    let pickupCountryCode = searchForm.pickUpCity.$modelValue.CountryCode;
    let pickupIsInternational = searchForm.pickUpCity.$modelValue.IsInternational;

    let dropoffLocation = searchForm.dropOffDepot.$modelValue.Name;
    let dropoffCode = searchForm.dropOffDepot.$modelValue.Value;
    let dropoffCity = searchForm.dropOffCity.$modelValue.City;
    let dropoffCityCode = searchForm.dropOffCity.$modelValue.CityCode;
    let dropoffCountry = searchForm.dropOffCity.$modelValue.Country;
    let dropoffCountryCode = searchForm.dropOffCity.$modelValue.CountryCode;
    let dropoffIsInternational = searchForm.pickUpCity.$modelValue.IsInternational;

    let searchObject = {
      PickUp: {
        Date: pickUpDateTimeParsed,
        Location: pickupLocation,
        Code: pickupCode,
        City: pickupCity,
        CityCode: pickupCityCode,
        Country: pickupCountry,
        CountryCode: pickupCountryCode,
        IsInternational: pickupIsInternational
      },
      DropOff: {
        Date: dropOffDateTimeParsed,
        Location: dropoffLocation,
        Code: dropoffCode,
        City: dropoffCity,
        CityCode: dropoffCityCode,
        Country: dropoffCountry,
        CountryCode: dropoffCountryCode,
        IsInternational: dropoffIsInternational
      }
    };

    if (pickupCode === 'other') {
      let pickUpDepot = {};

      pickUpDepot.Address = searchForm.pickUpOtherLocation.$modelValue.addressLabel;
      pickUpDepot.Code = searchForm.pickUpOtherLocation.$modelValue.code;
      pickUpDepot.FullCode = searchForm.pickUpOtherLocation.$modelValue.fullCode;
      pickUpDepot.Supplier = searchForm.pickUpOtherLocation.$modelValue.supplierId;

      searchObject.PickUp.Code = searchForm.pickUpCity.$modelValue.CityCode;
      searchObject.PickUp.Location = pickUpDepot.address;

      searchObject.PickUp.Depot = pickUpDepot;
    }

    if (dropoffCode === 'other') {
      let dropOffDepot = {};

      dropOffDepot.Address = searchForm.dropOffOtherLocation.$modelValue.addressLabel;
      dropOffDepot.Code = searchForm.dropOffOtherLocation.$modelValue.code;
      dropOffDepot.FullCode = searchForm.dropOffOtherLocation.$modelValue.fullCode;
      dropOffDepot.Supplier = searchForm.dropOffOtherLocation.$modelValue.supplierId;

      searchObject.DropOff.Code = searchForm.dropOffCity.$modelValue.CityCode;
      searchObject.DropOff.Location = dropOffDepot.address;

      searchObject.DropOff.Depot = dropOffDepot;
    }

    return searchObject;
  }

  function prepHotelFormData(searchForm) {
    let DATE_FORMAT_MEDIUM = $filter('translate')('dates.DateFormatMedium').replace(',', '[,]');
    let location = searchForm.hotelLocation.$modelValue;
    let radius = searchForm.radius.$modelValue.value;

    let checkIn = moment(searchForm.checkInDate.$modelValue, DATE_FORMAT_MEDIUM).format('YYYY-MM-DD[T]HH:mm:ss');
    let checkOut = moment(searchForm.checkOutDate.$modelValue, DATE_FORMAT_MEDIUM).format('YYYY-MM-DD[T]HH:mm:ss');

    return {
      DateFrom: checkIn,
      DateTo: checkOut,
      Location: {
        City: location.City.Name,
        Country: location.Country.Name,
        CountryCode: location.Country.Code,
        Location: location.Address,
        IsInternational: '',
        Code: location.City.Code,
        Name: location.Title,
        Type: location.Type,
        Latitude: location.Latitude,
        Longitude: location.Longitude,
        RadiusDistance: radius
      }
    }
  }

  function updateSearchChoices(choice) {
    const t = service.activeSearchTypes;
    const r = service.railOptions;

    switch (choice) {
      case "Flights":

        if (!t.Rail.active && !t.Hotels.active && !t.Cars.active) {
          t.Flights = {active: true, showForm: true};
        } else {
          t.Flights = {active: !t.Flights.active, showForm: !t.Flights.showForm};
        }

        if (t.Flights.active) {
          r.openReturn = false;
          r.return = true;
          t.Rail = {active: false, showForm: false};
          t.Hotels.showForm = false;
          t.Cars.showForm = false;
        } else {
          t.Hotels.showForm = t.Hotels.active;
          t.Cars.showForm = t.Cars.active;
        }

        if ((t.Cars.active || t.Hotels.active) && service.flightLegs === 1) {
          t.Cars = {active: false, showForm: false};
          t.Hotels = {active: false, showForm: false};
          t.Flights = {active: true, showForm: true};
        }

        break;

      case "Rail":

        if (!t.Flights.active && !t.Hotels.active && !t.Cars.active) {
          t.Rail.active = {active: true, showForm: true};
        } else {
          t.Rail = {active: !t.Rail.active, showForm: !t.Rail.showForm};
        }

        if (t.Rail.active) {
          t.Flights = {active: false, showForm: false};
          t.Hotels.showForm = false;
          t.Cars = {active: false, showForm: false};
        } else {
          t.Hotels.showForm = t.Hotels.active;
        }

        if (t.Rail.active && !service.railOptions.return) {
          t.Hotels = {active: false, showForm: false};
        }

        if(service.railOptions.openReturn) {
          t.Hotels = { active: false, showForm: false };
        }

        break;

      case "Hotels":
        const hotelActive = t.Hotels.active;

        if (!t.Flights.active && !t.Rail.active && !t.Cars.active) {
          t.Hotels = {active: true, showForm: true};
        } else {
          t.Hotels = {active: !t.Hotels.active, showForm: !t.Hotels.showForm};
        }

        if (t.Flights.active) {
          t.Hotels.showForm = false;
        }

        if (!t.Cars.active && service.flightLegs === 1) {
          t.Hotels = {active: false, showForm: false};
        }

        if (t.Flights.active && service.flightLegs === 1) {
          t.Hotels = {active: true, showForm: true};
          t.Flights = {active: false, showForm: false};
        }

        if (t.Rail.active) {
          if (!r.return || r.openReturn) {
            r.openReturn = false;
            r.return = true;
            t.Rail = {active: false, showForm: false};
            t.Hotels = {active: true, showForm: true};
          } else {
            if(hotelActive) {
              t.Hotels = { active: false, showForm: false };
            } else {
              t.Hotels = { active: true, showForm: false };
            }
          }
        }

        break;

      case "Cars":

        if (!t.Flights.active && !t.Rail.active && !t.Hotels.active) {
          t.Cars = {active: true, showForm: true};
        } else {
          t.Cars = {active: !t.Cars.active, showForm: !t.Cars.showForm};
        }

        if (t.Flights.active || t.Rail.active) {
          t.Cars.showForm = false;
        }

        if (t.Rail.active) {
          r.openReturn = false;
          r.return = true;
          t.Rail = {active: false, showForm: false};
          t.Cars = {active: true, showForm: true};
          t.Hotels.showForm = t.Hotels.active;
        }

        if (t.Flights.active && service.flightLegs === 1) {
          t.Cars = {active: true, showForm: true};
          t.Flights = {active: false, showForm: false};
        }

        break;
      default:
        console.warn("NO CART ITEM TYPE FOUND!");
    }
  }

  function updateFlightLegs(legs) {
    const t = service.activeSearchTypes;
    service.flightLegs = legs;

    if (service.flightLegs === 1) {
      t.Hotels = {active: false, showForm: false};
      t.Cars = {active: false, showForm: false};
    }
  }

  function updateRailReturn() {
    const t = service.activeSearchTypes;

    if (!service.railOptions.return) {
      t.Hotels = {active: false, showForm: false};
      t.Cars = {active: false, showForm: false};
    }
  }

  function updateRailOpenReturn() {
    const t = service.activeSearchTypes;

    if (service.railOptions.openReturn) {
      t.Hotels = {
        active: false,
        showForm: false
      };
    }
  }

  function validateThenPostForm(searchForm, travellers) {
    let DATE_FORMAT_MEDIUM = $filter('translate')('dates.DateFormatMedium').replace(',', '[,]');

    let deferred = $q.defer();

    if (searchForm.$invalid) {
      deferred.reject();
    }

    const t = service.activeSearchTypes;

    let orderNumber = searchForm.orderNumber ? searchForm.orderNumber.$modelValue : undefined;
    if (orderNumber) {
      orderNumber = orderNumber.hasOwnProperty('Value') ? orderNumber.Value : orderNumber;
    }

    let searchParams = {
      search: {
        Passengers: travellers,
        Reason: searchForm.reasonForTravel ? searchForm.reasonForTravel.$modelValue.Value : undefined,
        OrderNumber: orderNumber
      }
    };
    if (t.Flights.showForm) {

      let flightsAmount = searchForm.flightSearch.flightsAmount.$modelValue;

      for (let i = 0; i < flightsAmount; i++) {
        let flightDate = searchForm.flightSearch['flight' + (i + 1) + 'Date'].$modelValue;
        let flightTime = searchForm.flightSearch['flight' + (i + 1) + 'Time'].$modelValue;
        let flightDateTime = moment(flightDate + flightTime, DATE_FORMAT_MEDIUM + TIME_FORMAT).format('YYYY-MM-DD[T]HH:mm:ss');

        let destination = searchForm.flightSearch['flight' + (i + 1) + 'Arrival'].$modelValue;
        let destinationCode = destination.Value;
        let destinationName = destination.City + ', ' + destination.Country;
        let originCode = searchForm.flightSearch['flight' + (i + 1) + 'Departure'].$modelValue.Value;

        searchParams = addFlight(searchParams, flightDateTime, originCode, destinationCode);

        if (t.Hotels.active && i != flightsAmount - 1) {
          let nextFlightDate = searchForm.flightSearch['flight' + (i + 2) + 'Date'].$modelValue;
          let checkOut = moment(nextFlightDate + '0:00 AM', DATE_FORMAT_MEDIUM + 'h:mm A').format('YYYY-MM-DD[T]HH:mm:ss');
          let checkIn = moment(flightDate + '0:00 AM', DATE_FORMAT_MEDIUM + 'h:mm A').format('YYYY-MM-DD[T]HH:mm:ss');
          let location = {
            Title: destinationName,
            Code: destinationCode,
            Type: 'Airport'
          };

          searchParams = addHotel(searchParams, checkIn, checkOut, location);
        }

        if (t.Cars.active && i != flightsAmount - 1) {
          let nextFlightDate = searchForm.flightSearch['flight' + (i + 2) + 'Date'].$modelValue;
          let nextFlightTime = searchForm.flightSearch['flight' + (i + 2) + 'Time'].$modelValue;
          let dropOffDateTime = moment(nextFlightDate + nextFlightTime, DATE_FORMAT_MEDIUM + TIME_FORMAT).format('YYYY-MM-DD[T]HH:mm:ss');
          let dropOffCode = searchForm.flightSearch['flight' + (i + 2) + 'Departure'].$modelValue.Value;

          let searchObject = {
            PickUp: {
              Date: flightDateTime,
              Code: destinationCode
            },
            DropOff: {
              Date: dropOffDateTime,
              Code: dropOffCode
            }
          };

          searchParams = addCar(searchParams, searchObject);
        }
      }
    }

    if (t.Rail.showForm) {
      searchParams = service.prepRailFormData(searchForm, searchParams);

      if (t.Hotels.active) {
        const checkIn = searchParams.search.Rails[0].Date;
        const checkOut = searchParams.search.Rails[1].Date;

        const location = {
          Title: searchForm.railTo.$modelValue.CityName + ', ' + searchForm.railTo.$modelValue.CountryName,
          Code: searchForm.railTo.$modelValue.Iata,
          Type: 'Airport'
        };

        searchParams = addHotel(searchParams, checkIn, checkOut, location);
      }
    }

    if (t.Hotels.showForm) {
      let checkIn = moment(searchForm.checkInDate.$modelValue, DATE_FORMAT_MEDIUM).format('YYYY-MM-DD');
      let checkOut = moment(searchForm.checkOutDate.$modelValue, DATE_FORMAT_MEDIUM).format('YYYY-MM-DD');
      let location = searchForm.hotelLocation.$modelValue;
      location.Code = location.City.Code;

      searchParams = addHotel(searchParams, checkIn, checkOut, location);
    }

    if (t.Cars.showForm) {
      let searchObject = prepCarFormData(searchForm);
      searchParams = addCar(searchParams, searchObject);
    }

    itinerariesService.post(searchParams)
      .then((itineraryResponse) => {
        deferred.resolve(itineraryResponse);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function addFlight(searchParams, dateTime, originCode, destinationCode) {
    searchParams.search.Flights = searchParams.search.Flights || [];
    searchParams.search.Flights.push({
      Origin: {
        Code: originCode
      },
      Destination: {
        Code: destinationCode
      },
      Date: dateTime
    });

    return searchParams;
  }

  function addHotel(searchParams, checkIn, checkOut, location) {
    searchParams.search.Hotels = searchParams.search.Hotels || [];

    searchParams.search.Hotels.push({
      dateFrom: checkIn,
      dateTo: checkOut,
      Location: {
        Code: location.Code,
        Name: location.Title,
        Type: location.Type,
        Latitude: location.Latitude,
        Longitude: location.Longitude
      }
    });

    return searchParams;
  }

  function addCar(searchParams, searchObject) {
    searchParams.search.Cars = searchParams.search.Cars || [];
    searchParams.search.Cars.push(searchObject);

    return searchParams;
  }

  function prepRailFormData(searchForm, searchParams) {
    let from = {Code: searchForm.railFrom.$modelValue.Code};
    let to = {Code: searchForm.railTo.$modelValue.Code};
    let fromDate = `${searchForm.outboundDate.$modelValue} ${searchForm.outboundTime.$modelValue}`;
    let fromDateParsed = moment(fromDate, `DD MMM, YYYY ${TIME_FORMAT}`).format('YYYY-MM-DD[T]HH:mm:ss');
    let toDate = `${searchForm.returnDate.$modelValue} ${searchForm.returnTime.$modelValue}`;
    let toDateParsed = moment(toDate, `DD MMM, YYYY ${TIME_FORMAT}`).format('YYYY-MM-DD[T]HH:mm:ss');
    let railCardCode = undefined;
    let openReturn = searchForm.openReturn.$modelValue;

    if (searchForm.railCard && searchForm.railCard.$modelValue) {
      railCardCode = searchForm.railCard.$modelValue.InternalCode;
    }

    searchParams.search.Rails = [
      {
        Origin: from,
        Destination: to,
        Date: fromDateParsed,
        RailCardCode: railCardCode,
        OpenReturn: openReturn
      }
    ];

    if (searchForm.railReturn.$modelValue && !openReturn) {
      searchParams.search.Rails.push(
        {
          Origin: to,
          Destination: from,
          Date: toDateParsed,
          RailCardCode: railCardCode
        }
      )
    }

    return searchParams;
  }

  return service;
};

searchFormService.$inject = $inject;

export default searchFormService;



// WEBPACK FOOTER //
// ./src/services/searchFormService.js